import type { Config, Specific } from './types'
import { handleEvents } from './dom-events'
import { fetchApi } from './fetch-api'
import { processArgumentsQueue } from './arguments-queue'
import { getUserConfig, setUserId } from './user-config'
import {
  postMessageToFrame,
  updateIframesColorScheme,
} from './widget/widget-dom-api'
import { coreFrameId } from './constant'

const preloadHtmlFile = (file: string) => {
  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = `${process.env.RUNTIME_FRAME_URL}/${file}`
  link.crossOrigin = 'anonymous'

  document.head.appendChild(link)
}

const overrideHistoryObject = () => {
  const selectedHistory: History =
    // @ts-ignore
    'Backbone' in window && window.Backbone && window.Backbone.history
      ? // @ts-ignore
        window.Backbone.history
      : window.history

  const _wr = function (type: keyof History) {
    const orig = selectedHistory[type]

    return function (...i: any[]) {
      // @ts-ignore
      const rv = orig.apply(this, i)

      const e = new Event(type)
      window.dispatchEvent(e)
      return rv
    }
  }

  if (selectedHistory) {
    selectedHistory.pushState = _wr('pushState')
    selectedHistory.replaceState = _wr('replaceState')
  }
}

const watchColorScheme = () => {
  if (!window.matchMedia) {
    return
  }

  const darkSchemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  const lightSchemeMediaQuery = window.matchMedia(
    '(prefers-color-scheme: light)'
  )

  darkSchemeMediaQuery.addEventListener('change', updateIframesColorScheme)
  lightSchemeMediaQuery.addEventListener('change', updateIframesColorScheme)

  return () => {
    darkSchemeMediaQuery.removeEventListener('change', updateIframesColorScheme)
    lightSchemeMediaQuery.removeEventListener(
      'change',
      updateIframesColorScheme
    )
  }
}

export const previewConfigure = async (instance: Specific) => {
  preloadHtmlFile('preview.html')
  overrideHistoryObject()
  watchColorScheme()

  postMessageToFrame(coreFrameId, {
    type: 'specific.widget.user',
    visitorId: '',
  })

  processArgumentsQueue(instance)
}

export const configure = async (instance: Specific) => {
  preloadHtmlFile('core.html')
  overrideHistoryObject()
  watchColorScheme()

  const { appId } = instance

  const userConfig = getUserConfig(appId)
  const _config = await fetchApi<Config>({
    url: `/config`,
    method: 'POST',
    appId,
    ...userConfig,
  })

  setUserId({
    appId,
    visitorId: _config.user.visitorId,
    userId: _config.user.id || undefined,
    instance,
  })

  postMessageToFrame(coreFrameId, {
    type: 'specific.widget.user',
    visitorId: _config.user.visitorId,
    userId: _config.user.id || undefined,
  })

  processArgumentsQueue(instance)
  handleEvents(appId, _config)
}
